/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';
import { Environment } from '../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';
import { comOffline } from '../../../offline/servico';
import { buscarPlanoContas } from '../../../offline/cadastros';
export interface IListagemPlanoDeContas {
  id: string;
  label: string;
}
interface GetAllListPlanoDeContas {
  idplanoconta: string;
  descricao: string;
  grupo: string;
}
export interface IDetalhePlanoDeContas { 
  idpai: string;
  id: string;
  label: string;
}
interface CreatePlanoDeContas {
  idpai: string;
  idplanoconta: string;
  descricao: string;
}
type TComTotalCount = {
  data: IListagemPlanoDeContas[];
  totalCount: number;
}
type TComTotalCountGetAllList = {
  data: GetAllListPlanoDeContas[];
  totalCount: number;
}

interface ErrorResponse {
  errors: {
    default: string;
  };
}

const getAll = async (): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = '/planoconta';
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllistOnline = async (filter = '', id = '', limit = Environment.LIMITE_DE_LINHAS): Promise<TComTotalCountGetAllList | Error> => {
  try {
    // Só busca por id quando o usuário ainda não digitou nada — ver mesmo fix em
    // MunicipiosService.getAlllist.
    const urlRelativa: string = (filter === '' && id !== '') ? `/planoconta/${id}` : `/planocontalist?limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: CreatePlanoDeContas): Promise<string | Error> => {
  try {
    if(dados.idpai === 'null'){
      const { idpai, ...dadosIDetalheSaida } = dados;
      const { data } = await Api.post<CreatePlanoDeContas>('/planoconta', dadosIDetalheSaida);
      if (Object.keys(data).length === 0) {
        return 'ok';
      }
      return new Error('Erro ao criar o registro.');
    }else{
      const { data } = await Api.post<CreatePlanoDeContas>('/planoconta', dados);
      if (Object.keys(data).length === 0) {
        return 'ok';
      }
      return new Error('Erro ao criar o registro.');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, descricao: string): Promise<void | Error> => {
  try {
    if(id != 'null'){
      await Api.put(`/planoconta/${id}`, {descricao: descricao});
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// ---------- Offline (ver shared/offline) ----------
// `limit`: quantos planos trazer na lista (padrão LIMITE_DE_LINHAS). O
// AutoCompletePlanoDeContas pede a árvore inteira — com 7, só apareciam os
// primeiros do ATIVO, nunca os de receita/despesa.
const getAlllist = (filter = '', id = '', limit = Environment.LIMITE_DE_LINHAS): Promise<TComTotalCountGetAllList | Error> =>
  comOffline(
    () => getAlllistOnline(filter, id, limit),
    () => buscarPlanoContas(filter, filter === '' ? id : '', limit),
  );

export const PlanoDeContasService = {
  getAll,
  getAlllist,
  create,
  updateById,
};